import { Notification, NotificationStepStatus, NotifyStatus, NotificationType } from '@dynamik/common/clients/notification-clients';
import { Subject, takeUntil } from '../../../rxjs-local';
import { autoinject } from 'aurelia-dependency-injection';
import { NotificationService } from '../../../services/notification/notification-service';

declare module '@dynamik/common/clients/notification-clients' {
  interface Notification {
    expanded?: boolean;
    deleted?: boolean;
  }
}

@autoinject
export class NotificationsList {
  constructor(private notificationService: NotificationService) { }

  notifications: Notification[];
  destroy$ = new Subject<void>();
  NotificationStepStatus = NotificationStepStatus;
  NotifyStatus = NotifyStatus;
  NotificationType = NotificationType;

  async attached() {
    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe(x => {
        // restore expanded state before updating notifications
        this.notifications?.filter(n => n.expanded).forEach(n => {
          const newNotification = x.find(m => m.id === n.id);
          if (newNotification) {
            newNotification.expanded = true;
          }
        });
        this.notifications = x;
      });
  }

  detached() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async deleteNotification(n: Notification) {
    this.notificationService.deleteNotifications([n]);
  }

  copyToClipboard(n: Notification) {
    navigator.clipboard.writeText(n.id);
    this.notificationService.notifySuccess('Notification ID copied to clipboard');
  }

  dismissAll() {
    this.notificationService.deleteNotifications(this.notifications);
  }
}
